// removed by extract-text-webpack-plugin
module.exports = {"footerPromotions":"_3i5T3hrYP6KvqWBoOEIpGg","promotion":"_3s6l-4vbtefPuYGdqnb8lW","footerPromotion":"_3-AbB4lFMtGKwU2-QjLbrT","a-promotion-href":"WQdtGbEQoPwGxz6obBLb-"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FooterPromotions/style.scss
// module id = 947
// module chunks = 0